module.exports = __webpack_public_path__ + "img/5-twoImg.df58922b.png";